import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "../../components/feature/sections/HeroSection";
import TrustBar from "../../components/feature/sections/TrustBar";
import ServicesGrid from "../../components/feature/sections/ServicesGrid";
import AIAnswerBlock from "../../components/feature/sections/AIAnswerBlock";
import ProcessSection from "../../components/feature/sections/ProcessSection";
import WhyChooseUs from "../../components/feature/sections/WhyChooseUs";
import ServiceAreasSection from "../../components/feature/sections/ServiceAreasSection";
import TestimonialsSection from "../../components/feature/sections/TestimonialsSection";
import FAQSection from "../../components/feature/sections/FAQSection";
import FinalCTASection from "../../components/feature/sections/FinalCTASection";
import LeadFormSection from "../../components/feature/sections/LeadFormSection";
import { KRP_SERVICES, KRP_WHY_CHOOSE } from "../../mocks/krp-data";

const heroContent = {
  badge: "A Family Legacy of Excellence",
  headline: "Built on Passion,",
  headlineAccent: "Perfected by Craft.",
  subheadline: "The story of a family-owned firm that turned a love of design into South Florida\u2019s most trusted kitchen renovation company.",
  description: "Based in Boca Raton \u00b7 4.9-star rated \u00b7 500+ projects \u00b7 Family-owned since day one",
  primaryCta: "Meet Our Team",
  primaryCtaPath: "/about",
  secondaryCta: "See Our Work",
  secondaryCtaPath: "/services",
  backgroundImage:
    "https://public.readdy.ai/ai/img_res/fbebc726f0db4fb0566ef7e30c0e0b79.jpg",
};

const aboutValuesContent = {
  badge: "Our Core Values",
  headline: "Services Built on",
  headlineAccent: "Principle.",
  subtext:
    "Every service we provide is grounded in the same core values that have guided KRP since the beginning: honesty, craftsmanship, and a relentless pursuit of the extraordinary.",
  services: KRP_SERVICES.slice(0, 3),
  ctaLabel: "Explore All Services",
  ctaPath: "/services",
};

const aiBlockContent = {
  badge: "Who We Are",
  headline: "Kitchen Renovations Perfected: The KRP Story",
  body:
    "Kitchen Renovations Perfected (KRP) was founded on a simple but powerful belief: that every South Florida family deserves a beautifully designed, expertly renovated kitchen. Based at Boca Center in Boca Raton, Florida, KRP has grown into a premier design-build firm trusted by homeowners across Palm Beach County, Broward County, and beyond. As a family-owned business, we bring personal accountability and genuine care to every project. We don\u2019t just deliver renovations \u2014 we deliver promises. Our team includes expert designers, skilled craftsmen, and project managers who treat your home with the same respect as their own. Our Boca Raton showroom is where ideas become designs, and designs become the kitchens and bathrooms our clients have always dreamed of.",
  bullets: [
    "Family-owned and operated with deep roots in South Florida",
    "Full design-build capability \u2014 design, permits, installation under one roof",
    "Showroom located at Boca Center, open by appointment",
    "4.9-star reputation built on 150+ verified client reviews",
    "Serving Boca Raton, Delray Beach, and all of South Florida",
  ],
  ctaLabel: "Start Your Project With Us",
  ctaPath: "/locations",
  image1:
    "https://readdy.ai/api/search-image?query=design%20team%20consultation%20homeowner%20kitchen%20design%20review%20blueprints%20samples%20South%20Florida%20professional%20designer%20meeting%20warm%20editorial%20photography%20high%20end%20residential%20design%20studio%20meeting%20warm%20lighting%20professional%20atmosphere&width=800&height=600&seq=6020&orientation=landscape",
  image2:
    "https://readdy.ai/api/search-image?query=family%20owned%20business%20team%20portrait%20interior%20design%20firm%20South%20Florida%20Boca%20Raton%20professional%20warm%20editorial%20photography%20friendly%20confident%20professional%20attire%20studio%20background%20premium&width=600&height=450&seq=6030&orientation=landscape",
};

const missionContent = {
  badge: "Our Mission",
  headline: "We Don\u2019t Stop",
  headlineAccent: "Until It\u2019s Perfect.",
  subtext:
    "Our mission is embedded in our name. Every decision we make \u2014 from design to installation \u2014 is guided by a commitment to perfection.",
  steps: [
    {
      step: "01",
      title: "Integrity First",
      description: "We provide transparent pricing, honest timelines, and clear communication from the first consultation through the final walkthrough.",
      icon: "ri-shield-check-line",
    },
    {
      step: "02",
      title: "Design Excellence",
      description: "Our design team blends aesthetic vision with functional expertise to create spaces that are as beautiful to live in as they are to look at.",
      icon: "ri-palette-line",
    },
    {
      step: "03",
      title: "Artisan Craft",
      description: "Every cabinet, countertop, and tile is installed with the precision and care of a craftsman who takes personal pride in the outcome.",
      icon: "ri-tools-line",
    },
    {
      step: "04",
      title: "Your Satisfaction",
      description: "We don\u2019t consider a project finished until you walk through your new space with a smile. Your complete satisfaction is our only definition of done.",
      icon: "ri-heart-line",
    },
    {
      step: "05",
      title: "Lasting Relationships",
      description: "Many of our clients return for additional projects and refer family and friends. That kind of trust is the highest compliment we can receive.",
      icon: "ri-user-heart-line",
    },
  ],
};

const whyUsContent = {
  badge: "The KRP Advantage",
  headline: "What Makes KRP",
  headlineAccent: "Different.",
  subtext:
    "In a market full of contractors, KRP stands apart as a true design-build partner \u2014 one that brings creativity, craftsmanship, and accountability to every project.",
  reasons: KRP_WHY_CHOOSE,
  ctaLabel: "See Our Services",
  ctaPath: "/services",
};

const areasContent = {
  badge: "Our Reach",
  headline: "Proudly Serving All of South Florida",
  body:
    "From our headquarters at Boca Center in Boca Raton, the KRP team travels across South Florida to bring exceptional kitchen and bath design to homeowners who won\u2019t accept anything less than the best.",
  ctaLabel: "Find Your Location",
  ctaPath: "/locations",
};

const testimonialsContent = {
  badge: "Client Testimonials",
  headline: "The Words That Drive Us.",
  subtext: "These reviews are the reason we come to work every day. Real words from real South Florida homeowners.",
};

const faqContent = {
  badge: "About KRP",
  headline: "Questions About Our Company",
  subtext: "Learn more about who we are, how we work, and what makes KRP the right choice for your South Florida home.",
  faqs: [
    {
      question: "Is Kitchen Renovations Perfected a family-owned business?",
      answer:
        "Yes. KRP is a family-owned and operated design-build firm. This means you\u2019re working directly with people who have a personal stake in your satisfaction and who bring genuine passion to every project they undertake in South Florida.",
    },
    {
      question: "Where is KRP\u2019s showroom located?",
      answer:
        "Our showroom is at Boca Center: 5250 Town Center Cir #109, Boca Raton, FL 33486. We\u2019re open Monday through Friday, 10:00 AM to 5:00 PM, by appointment. Call (561) 441-6008 or contact us online to schedule your visit.",
    },
    {
      question: "How long has Kitchen Renovations Perfected been in business?",
      answer:
        "KRP has been transforming South Florida kitchens and bathrooms for over a decade. In that time, we\u2019ve completed 500+ projects and built a 4.9-star reputation that speaks to our consistent quality and client-first approach.",
    },
    {
      question: "Does KRP work with homeowners directly or through contractors?",
      answer:
        "We work directly with homeowners. As a design-build firm, KRP manages the entire process in-house, which means you always have direct access to the people making decisions about your renovation.",
    },
    {
      question: "What is the contact information for Kitchen Renovations Perfected?",
      answer:
        "You can reach KRP by phone at (561) 441-6008, by email at elliott@kitchenrp.com, or in person at our Boca Raton showroom at 5250 Town Center Cir #109. We\u2019re available Monday through Friday, 10:00 AM to 5:00 PM.",
    },
  ],
};

const finalCTAContent = {
  badge: "Work With KRP",
  headline: "Let\u2019s Build Something",
  headlineAccent: "Beautiful Together.",
  description:
    "Your renovation begins with a single conversation. Contact our team today for a complimentary consultation at our Boca Raton showroom or in your home.",
  primaryCta: "Schedule a Consultation",
  primaryCtaPath: "/locations",
  secondaryCta: "Call (561) 441-6008",
  secondaryCtaHref: "tel:5614416008",
  backgroundImage:
    "https://readdy.ai/api/search-image?query=beautiful%20luxury%20kitchen%20complete%20renovation%20cream%20warm%20cabinetry%20tall%20shaker%20doors%20marble%20slab%20countertops%20antique%20gold%20fixtures%20pendant%20lights%20hardwood%20plank%20floors%20South%20Florida%20luxury%20home%20professional%20interior%20architecture%20photography%20warm%20cinematic%20editorial%20style&width=1600&height=1000&seq=6040&orientation=landscape",
};

export default function AboutPage() {
  return (
    <main>
      <Navbar />
      <HeroSection content={heroContent} />
      <TrustBar />
      <ServicesGrid content={aboutValuesContent} />
      <AIAnswerBlock content={aiBlockContent} />
      <ProcessSection content={missionContent} />
      <WhyChooseUs content={whyUsContent} />
      <ServiceAreasSection content={areasContent} />
      <TestimonialsSection content={testimonialsContent} />
      <FAQSection content={faqContent} />
      <LeadFormSection variant="light" />
      <FinalCTASection content={finalCTAContent} />
      <Footer />
    </main>
  );
}
